"use client";

import React from "react";

//Types
import { TitleProps } from "@/types";

//Styles
import * as S from "./styles";

const TitleStrong: React.FC<TitleProps> = ({ className, Title }) => {
  return <S.Title className={className}>{Title}</S.Title>;
};

export default TitleStrong;
